
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/user/payment/itp/error",
      function () {
        return require("private-next-pages/user/payment/itp/error/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/user/payment/itp/error"])
      });
    }
  